export default __webpack_public_path__ + "static/richmond_bg_people-5f2c5aee783d2a0bb38651b63f86d7dd.jpeg";